import { uploadOss } from './api/oss.js';
import dataURItoBlob from './data-uri-to-blob.js';
import { putWork, uploadWork } from './api/work.js';
import CryptoJS from 'crypto-js';

// 计算MD5
function calculateMd5(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onloadend = function() {
            const wordArray = CryptoJS.lib.WordArray.create(reader.result);
            const hash = CryptoJS.MD5(wordArray).toString();
            // or CryptoJS.SHA256(wordArray).toString(); for SHA-2
            // console.log("MD5 Checksum", hash);
            // callback(hash);
            resolve(hash);
        };
    });
}

// function getProjectCover(e) {
//     const callback = e.detail.callback;
//     this.props.vm.postIOData('video', { forceTransparentPreview: true });
//     this.props.vm.renderer.requestSnapshot(dataURI => {
//         this.props.vm.postIOData('video', { forceTransparentPreview: false });
//         callback(dataURI);
//     });
//     this.props.vm.renderer.draw();
// }



/**
 * 上传文件
 * @param {string} filename 文件名字
 * @param {Blob} 文件blob
 * @param {number} id 作品id
 * @param {function} mainCallBack  上传成功回调
 * @param {function} errorCallBack 上传失败回调
 */
export default (filename, blockImg, blob, id, mainCallBack, errorCallBack) => {
    // console.log(blockImg, 'blockImg');
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    // blob to md5
    calculateMd5(blob).then(md5 => {
        // console.log("文件MD5", md5, filename);
        // 上传文件唯一标志符
        const uploadSymbol = `${md5}.${filename.split('.')[1] || '.py'}`;
        // Use special ms version if available to get it working on Edge.
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, uploadSymbol);
            return;
        }
        // blob to file
        const file = new File([blob], uploadSymbol, {
            type: blob.type,
            lastModified: Date.now()
        });
        const formData = new FormData();
        formData.append('sb3', file);
        uploadOss(
            'sb3',
            file,
            null,
            null,
            null,
            null,
            callBack => {
                console.log(callBack, 'callBack');
                // window.scratch.getProjectCover(cover => {
                // console.log(cover, 'cover');
                // if (cover.length <= 6) {
                // eslint-disable-next-line max-len
                // cover = 'data:image/svg+xml;base64,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';
                let cover = blockImg;
                // }
                const imgBlob = dataURItoBlob(cover);
                const imageFile = new File([imgBlob], `${uploadSymbol}.svg`, {
                    type: imgBlob.type,
                    lastModified: Date.now()
                });
                uploadOss('img', imageFile, null, null, null, null, callBack2 => {
                    new Promise((resolve, reject) => {
                            if (id !== null && id > 0) {
                                putWork(resolve, reject, {
                                    title: filename.split('.')[0],
                                    cover: callBack2,
                                    sourceUrl: callBack,
                                    id: id
                                });
                            } else {
                                uploadWork(resolve, reject, {
                                    title: filename.split('.')[0],
                                    cover: callBack2,
                                    sourceUrl: callBack,
                                    type: 6,
                                    courseType: 4
                                });
                            }
                        })
                        .then(response => {
                            // console.log(response);
                            mainCallBack(response.data);
                        })
                        .catch(error => {
                            console.log(error);
                            errorCallBack(error);
                        });
                });
                // });
            },
            errorCallBack
        );
    });
};